import { getApiErrorStatus } from '@/core/utils/api-error.utils';

/**
 * Backend list caps the app must respect. Prefer matching the DTO `@Max` /
 * controller clamp for the resource — ValidationPipe rejects over-max limits
 * (400/422) instead of clamping when `@Max` is used (e.g. profile-templates).
 */

/** `QueryProfileTemplatesDto` `@Max(50)`. */
export const PROFILE_TEMPLATES_PAGE_MAX = 50;

/**
 * Common controller clamp / `LIST_PAGE_HARD_CAP` (locations, teams, members,
 * leads, lead-events, products, …).
 */
export const LIST_PAGE_HARD_CAP = 100;

/** Safety guard for client-side “fetch all pages” loops (~10k rows). */
export const LIST_FETCH_ALL_MAX_PAGES = 100;

/** HTTP statuses that must never be auto-retried (bad request / auth / not found). */
export function isNonRetryableApiStatus(status: number | undefined): boolean {
  if (status == null) return false;
  if (status === 408 || status === 429) return false;
  return status >= 400 && status < 500;
}

/**
 * React Query `retry` default: at most one retry, and never for 4xx (except
 * 408/429). Stops validation / auth failures from hammering the API.
 */
export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  if (failureCount >= 1) return false;
  const status = getApiErrorStatus(error);
  if (isNonRetryableApiStatus(status)) return false;
  return true;
}
